import { PlainDate } from "@kiss-solutions/plaindate"
import { DateTime } from "luxon"

export const dataGridDateValueGetter = (value) => value && new Date(value)
export const dataGridDateTimeValueGetter = (value, timezone = 'Europe/Berlin') => value && DateTime.fromISO(value, { zone: timezone }).toLocaleString(DateTime.DATETIME_SHORT)

export const dataGridDateTimeValueGetterAsDate = (value, timezone = 'Europe/Berlin') => value && DateTime.fromISO(value, { zone: timezone }).toLocaleString(DateTime.DATE_SHORT)
export const convertDateStringToDateIgnoringTimezone = (dateString) => {
    if (!dateString) {
        return null;
    }
    return new PlainDate(dateString).toLocalDate();
}

export const convertISOToLocalDate = (isoDateString, timezone = 'Europe/Berlin') => {
    if (!isoDateString) return null;
    
    const dt = DateTime.fromISO(isoDateString).setZone(timezone);
    return new Date(dt.year, dt.month - 1, dt.day, dt.hour, dt.minute, dt.second, dt.millisecond);
}